import React, { useContext } from "react";
import { RootStoreContext } from "../../../app/stores/rootStore";

const TenantFilterInfo = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { getTenantFilterInfo } = rootStore.reportStore;

  return (
    <div      
      dangerouslySetInnerHTML={{ __html: getTenantFilterInfo() }}
    ></div>
  );
};

export default TenantFilterInfo;
